import type { FormInstance } from 'antd';
import { Form, Input } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import TextArea from 'antd/es/input/TextArea';
import classNames from 'classnames';

import { CoverPicture } from 'app/components/commons/CoverPicture/CoverPicture';
import type { IEditoEventForm } from 'app/typings/edito';

import { HeaderWrapper } from '../../HeaderWrapper/HeaderWrapper';

import { EditoSectionActionForm } from './ActionForm/EditoSectionActionForm';
import './EditoSectionsForm.scss';

type Props = {
  fieldName: string | number;
  form: FormInstance<IEditoEventForm>;
  type: 'sections' | 'endingBlock';
};

const ARRAY_OF_PICTURES_INDEX = [0, 1, 2];

export const EditoSectionsForm = ({ fieldName, form, type }: Props) => {
  const isEndingBlock = type === 'endingBlock';

  const formItemName = isEndingBlock ? 'endingBlock' : fieldName;

  return (
    <div
      className={classNames('editoSectionsForm', {
        removePadding: isEndingBlock,
      })}
    >
      <HeaderWrapper title="Section title" addTitleOptional>
        <FormItem name={[formItemName, 'title']}>
          <Input placeholder="ex. Massés comme jamais" />
        </FormItem>
      </HeaderWrapper>

      <HeaderWrapper title="Section description" addTitleOptional>
        <FormItem name={[formItemName, 'description']}>
          <TextArea placeholder="ex. Palpez, roulez, détendez-vous." />
        </FormItem>
      </HeaderWrapper>

      {!isEndingBlock && (
        <HeaderWrapper title="Image" addTitleOptional>
          <div className="imageRow">
            {ARRAY_OF_PICTURES_INDEX.map((index) => (
              <Form.Item name={[formItemName, 'pictures', index]} key={index}>
                <CoverPicture />
              </Form.Item>
            ))}
          </div>
        </HeaderWrapper>
      )}

      <HeaderWrapper title="Action" addTitleOptional>
        <EditoSectionActionForm form={form} fieldName={fieldName} type={type} />
      </HeaderWrapper>
    </div>
  );
};
